<!--
  ~ Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
  ~ This software is the proprietary information of NEXTWELL INTL SRL.
  ~ Use is subject to license and non-disclosure terms
  -->

<div class="row my">
  <div class="col-11" style="font-size: small;">
    <span *ngIf="addressForm?.addressLabel">{{addressForm?.addressLabel}}, </span>
    <span *ngIf="addressForm?.addressLine">{{addressForm?.addressLine}}, </span>
    <span *ngIf="addressForm?.city">{{addressForm?.city}}, </span>
    <span *ngIf="addressForm?.postalCode">{{addressForm?.postalCode}}, </span>
    <span *ngIf="addressForm?.state">{{addressForm?.state}}, </span>
    <span *ngIf="addressForm?.country">{{addressForm?.country}}</span>
  </div>

  <button *ngIf="editString" pButton class="link flat col-1" icon="ui-icon-edit" (click)="editAddress()" data-testid="edit-address-btn">  </button>



</div>




